import { useEffect } from "react";
import { GridStack } from "gridstack";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import RegionTree from "../RegionManagement/RegionList/RegionTree/RegionTree";
import "./Region.css";
import DMSHeader from "../DMSHeader/DMSHeader";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

// RegionManagement component - Main component for managing regions in a grid layout.
const RegionManagement = () => {
  const { t } = useTranslation();

  // Initialize GridStack layout on component mount
  useEffect(() => {
    GridStack.init();
  }, []);

  // Displays a success toast notification when regions are refreshed
  function refreshRegionList(msg) {
    toast.success(msg, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000, // Close after 2 seconds
    });
  }

  //  Layout configuration for the grid items
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: <DMSHeader title={t("region_management_header")} />,
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 5,
      width: 12,
      height: 11,
      id: 2,
      component: (
        <div>
          <RegionTree refreshRegionList={refreshRegionList} />
        </div>
      ),
    },
  ];
  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};
export default RegionManagement;